import { useMutation, useQueryClient } from 'react-query';

import apiEndPoints from 'services/apiEndPoints';
import makeApiRequest from 'services/makeApiRequest';
import { SuccessToast, ErrorToast } from 'services/toasterService';

export default function UsepostApprovepayroll() {
  const queryClient = useQueryClient();
  return useMutation(
    async (data) => {
      const response = await makeApiRequest.post(
        apiEndPoints.APPROVE_PAYROLL_API,
        data
      );
      return response.data;
    },
    {
      onSuccess: (data) => {
        queryClient.invalidateQueries('employee-payroll-data');
        queryClient.invalidateQueries('organisation_payroll');
        queryClient.invalidateQueries('employee-payroll-data1');
        SuccessToast({ text: data.message });
      },
      onError: (error) => {
        ErrorToast({ text: error.response.data.message });
      },
    }
  );
}
